import { employeeFlag } from "../../../constants/employeeFlag";
import { isSqeLabsContext } from "../../../v2/hooks/use-sqe-labs.ts";

export const LeaveSegment = {
  DEFAULT: "DEFAULT",
  US: "US",
  SQE: "SQE",
};

export function resolveLeaveSegment(user) {
  const location = String(user?.location ?? "").toUpperCase();
  if (isSqeLabsContext()) return LeaveSegment.SQE;
  if (location === employeeFlag.CCI_US) return LeaveSegment.US;

  return LeaveSegment.DEFAULT;
}
